var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.00004C2 5.63185 2.29848 5.33337 2.66667 5.33337H13.3333C13.7015 5.33337 14 5.63185 14 6.00004C14 6.36823 13.7015 6.66671 13.3333 6.66671H2.66667C2.29848 6.66671 2 6.36823 2 6.00004Z",
    fill: "#858A97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 9.63185 2.29848 9.33337 2.66667 9.33337H13.3333C13.7015 9.33337 14 9.63185 14 10C14 10.3682 13.7015 10.6667 13.3333 10.6667H2.66667C2.29848 10.6667 2 10.3682 2 10Z",
    fill: "#858A97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74031 1.33739C7.10624 1.37805 7.36993 1.70766 7.32927 2.0736L5.99594 14.0736C5.95528 14.4395 5.62567 14.7032 5.25973 14.6626C4.89379 14.6219 4.6301 14.2923 4.67076 13.9264L6.0041 1.92636C6.04476 1.56042 6.37437 1.29673 6.74031 1.33739Z",
    fill: "#858A97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7403 1.33739C11.1062 1.37805 11.3699 1.70766 11.3293 2.0736L9.99594 14.0736C9.95528 14.4395 9.62567 14.7032 9.25973 14.6626C8.89379 14.6219 8.6301 14.2923 8.67076 13.9264L10.0041 1.92636C10.0448 1.56042 10.3744 1.29673 10.7403 1.33739Z",
    fill: "#858A97"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashIcon);
export default __webpack_public_path__ + "static/media/hash-icon.48bdfada.svg";
export { ForwardRef as ReactComponent };